import {HttpParams} from '@angular/common/http';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BaseComponent, CatalogManufactures, Manufacturer} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';

@Component({
  selector: 'app-manufactures-autocomplete',
  templateUrl: './manufactures.component.html'
})
export class ManufacturesComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() model: any;
  @Output() removeTermEvent = new EventEmitter<Manufacturer>();
  @Output() insertTermEvent = new EventEmitter<Manufacturer>();
  @Output() updateTermEvent = new EventEmitter<CatalogManufactures[]>();

  inputFormControl: UntypedFormControl;
  terms$: Observable<Manufacturer[]>;
  termsExists = false;

  ngOnInit(): void {
    this.inputFormControl = new UntypedFormControl();
    this.terms$ = this.inputFormControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(term => term !== null),
        map((term: string) => term.length < 2 ? null : term),
        switchMap((term: string) => this.searchTerms(term)),
      );
  }

  ngOnChanges() {
    if (this.model) {
      this.termsExists = true;
    }
  }

  searchTerms(term: string): Observable<Manufacturer[]> {
    const url = '/manufacturer/search';
    if (null === term) {
      return of([]);
    }
    const params = new HttpParams().set('header', term);

    return this.compoApiService.getWithParams<Manufacturer[]>(url, params).pipe(
      map(response => response.data),
      map(response => 0 === response.length ?
        [{id: 0, header: translations.noResults, syncUid: '', enabled: false, content: ''}] : response
      )
    );

  }

  insertTerm(term: Manufacturer) {
    if (term) {
      this.insertTermEvent.emit(term);
      this.inputFormControl.setValue('');
    }
  }

  removeTerm(term: Manufacturer) {
    this.confirm(translations.confirmDelete + ' ' + translations.relationship + '?', new Observable(() => {
      this.removeTermEvent.emit(term);
    }));
  }

  viewHandle(value: string) {
    return value;
  }

  saveWeights() {
    this.updateTermEvent.emit(this.model);
  }
}
